import React, { useEffect, useState } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'

const scroller = Scroll.scroller

const DieselIFrame = ({src, scrollToPosition, id}) => {
    const [currentHeight, setCurrentHeight] = useState(1020)
    // const message = { type: "heightChanged", payload: 1652 }

    const isMobile = () => {
        const width = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '')

        return width < config.breakpoints.slidebarRight
    }

    const scrollIframeIntoView = (isMobile, iframe) => {
        if(isMobile) {
            iframe.scrollIntoView({
                behavior: 'smooth'
            })
        } else {
            scroller.scrollTo(scrollToPosition + ' performance-iframe', {
                smooth: true,
                offset: -200,
                isDynamic: true
            })
        }
    }

    const onScrollPositionAdvice = (iframe, header) => {
        const mobile = isMobile()
        const iFrameBounding = iframe.getBoundingClientRect()
        const headerBounding = header.getBoundingClientRect()

        if(mobile || iFrameBounding.top < headerBounding.height + 20) {
            scrollIframeIntoView(mobile, iframe)
        }
    }

    useEffect(() => {
        const iframe = document.getElementById(id)
        const header = document.getElementById('site-header')
        window.addEventListener('message', (event) => {
            if(event.data && event.data.type === "heightChanged") {
                if(event.data.payload && event.data.payload !== currentHeight) {
                    setCurrentHeight(event.data.payload)
                }
            }
            if(event.data && event.data.type === "requestScrollUp") {
                onScrollPositionAdvice(iframe, header)
            }
        })
        
        return () => {
            window.removeEventListener('message', (event) => {
                if(event.data && event.data.type === "heightChanged") {
                    if(event.data.payload && event.data.payload !== currentHeight) {
                        setCurrentHeight(event.data.payload)
                    }
                }
                if(event.data && event.data.type === "requestScrollUp") {
                    onScrollPositionAdvice(iframe, header)
                }
            })
        }
    })

    const style = {        
        minHeight: currentHeight + 'px'
    }

    return (
        <div id="diesel-iframe" className='theme-radius-posters-full'>
            <iframe 
                style={style} 
                id={id} 
                src={src}
            />
            {/* <div> */}
                {/* <div is="soft-seat-reservation"></div> */}
                {/* <soft-seat-reservation cinema-hall-id={showId}></soft-seat-reservation> */}
            {/* </div> */}
        </div>
    )  
}
// customElements.define("soft-seat-reservation", DieselIFrameWebComponent, { extends: "div" });

export default DieselIFrame